import styled from 'styled-components'

export const Container = styled.div`
  display: flex;
  flex-wrap: wrap;
  font-family: 'Helvetica New', 'Helvetica', sans-serif;
  max-width: 800px;
  margin: 0 10px;
`

export const Nav = styled.div`
  min-width: 150px;
  margin: 10px 0;

  @media (max-width: 800px) {
    min-width: 100%;
  }
`

export const Main = styled.div`
  width: 75%;
  padding: 0 15px;
  @media (max-width: 800px) {
    min-width: calc(100% - 30px);
  }
`



// WEBPACK FOOTER //
// ./src/components/layout.js